var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "fee-item-info clearfix",
      class: { client: _vm.currentUserIsClient },
    },
    [
      _vm.currentUserIsClient
        ? _c(
            "div",
            { staticClass: "fee-item-select" },
            [
              _vm.paymentsStatus.paymentsAreLoading
                ? _c("div", { staticClass: "round-choice-transparent" }, [
                    _c("span", {
                      staticClass: "content-title fas fa-lg fa-spinner fa-spin",
                    }),
                  ])
                : [
                    !_vm.paymentsStatus.somePaymentsArePending ||
                    _vm.paymentsStatus.somePaymentsAreNotPending
                      ? _c("div", { staticClass: "round-choice-content" }, [
                          _c("input", {
                            staticClass: "input-choice",
                            attrs: {
                              id: `checkbox-${_vm.relatedPaymentId}`,
                              type: "checkbox",
                              disabled: _vm.disabled,
                            },
                            domProps: {
                              value: `${_vm.relatedPaymentId}`,
                              checked:
                                _vm.paymentsStatus.selectablePayments.length ===
                                0,
                            },
                            on: {
                              change: function ($event) {
                                return _vm.$emit("change", {
                                  checked: $event.target.checked,
                                  selection:
                                    _vm.paymentsStatus.selectablePayments
                                      .length !== 0
                                      ? _vm.paymentsStatus.selectablePayments
                                      : _vm.paymentsStatus.unselectablePayments,
                                })
                              },
                            },
                          }),
                          _c("label", {
                            staticClass: "label-choice transition-fast",
                            attrs: { for: `checkbox-${_vm.relatedPaymentId}` },
                          }),
                        ])
                      : _c(
                          "div",
                          [
                            _c(
                              "b-tooltip",
                              {
                                attrs: {
                                  type: "is-white",
                                  label: "Pago en revisión",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "round-choice-content payment-is-pending",
                                  },
                                  [
                                    _c("input", {
                                      staticClass: "input-choice",
                                      attrs: {
                                        type: "checkbox",
                                        disabled: true,
                                      },
                                      domProps: { checked: true },
                                    }),
                                    _c("label", {
                                      staticClass:
                                        "label-choice transition-fast",
                                    }),
                                  ]
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                  ],
            ],
            2
          )
        : _vm._e(),
      _c("div", { staticClass: "fee-item-resume-content" }, [
        _c(
          "div",
          { staticClass: "type-content" },
          [
            _c(
              "b-tooltip",
              {
                attrs: {
                  label: "Crédito hipotecario y consumo",
                  size: "is-small",
                  type: "is-white",
                  multilined: "",
                },
              },
              [_c("span", [_vm._v("🏡 +💰")])]
            ),
          ],
          1
        ),
        _c("div", { staticClass: "price-content" }, [
          !_vm.disabled &&
          !_vm.paymentsStatus.anyPaymentsInPaymentsMap &&
          _vm.paymentsStatus.somePaymentsAreNotPending
            ? _c("div", { staticClass: "show-fee-label big-size-text" }, [
                _c(
                  "label",
                  {
                    staticClass: "is-clickable content-title",
                    attrs: { for: `checkbox-${_vm.relatedPaymentId}` },
                  },
                  [_c("span", [_vm._v("Ver cuota")])]
                ),
              ])
            : _vm.paymentsStatus.anyPaymentsInPaymentsMap ||
              _vm.paymentsStatus.somePaymentsArePending
            ? _c("div", { staticClass: "big-size-text" }, [
                _c(
                  "span",
                  {
                    staticClass: "content-title",
                    attrs: { id: `${_vm.relatedPaymentId}-amount` },
                  },
                  [
                    _vm._v(
                      " $ " +
                        _vm._s(
                          _vm.formatNumber(
                            _vm.paymentsStatus.selectablePayments.length ===
                              0 &&
                              _vm.paymentsStatus.unselectablePayments.length ===
                                0
                              ? _vm.paymentsStatus
                                  .totalTransactionPaymentsAmount
                              : _vm.paymentsStatus.totalAmount
                          )
                        ) +
                        " "
                    ),
                  ]
                ),
              ])
            : _c("div"),
        ]),
        _c("div", { staticClass: "duration-content med-size-text" }, [
          _c("div", [
            _c("span", { staticClass: "content-title" }, [_vm._v("Cuota:")]),
            _c("span", { staticClass: "content-value" }, [
              _vm._v(_vm._s(_vm.payments[0].paymentNumber)),
            ]),
          ]),
          _c("div", [
            _c(
              "span",
              {
                class:
                  _vm.payments[0].lateDays > 0
                    ? "alert-content-title"
                    : "content-title",
              },
              [
                _vm._v(
                  " " +
                    _vm._s(
                      _vm.payments[0].lateDays > 0 ? "Venció:" : "Vence:"
                    ) +
                    " "
                ),
              ]
            ),
            _c("span", { staticClass: "content-value" }, [
              _vm._v(_vm._s(_vm.dateToClientFormat(_vm.payments[0].dueDate))),
            ]),
          ]),
        ]),
        !_vm.currentUserIsClient
          ? _c(
              "div",
              { staticClass: "late-days-content med-size-text" },
              [
                _c(
                  "b-tooltip",
                  { attrs: { label: "Días de mora", type: "is-white" } },
                  [
                    _c(
                      "div",
                      {
                        staticClass: "tag med-size-text is-danger",
                        class:
                          _vm.payments[0].lateDays >= 90
                            ? "ninety-days"
                            : _vm.payments[0].lateDays >= 60
                            ? "sixty-days"
                            : _vm.payments[0].lateDays >= 30
                            ? "thirty-days"
                            : _vm.payments[0].lateDays >= 11
                            ? "less-than-thirty-days"
                            : "healthy-days",
                      },
                      [_vm._v(" " + _vm._s(_vm.payments[0].lateDays) + " ")]
                    ),
                  ]
                ),
              ],
              1
            )
          : _vm._e(),
      ]),
      _vm.paymentsStatus.anyPaymentsInPaymentsMap ||
      _vm.paymentsStatus.somePaymentsArePending
        ? _c("div", { staticClass: "details-content" }, [
            _c(
              "a",
              {
                attrs: { id: `extend-${_vm.relatedPaymentId}`, href: "#" },
                on: {
                  click: function ($event) {
                    $event.preventDefault()
                    return _vm.$emit("extend-payment")
                  },
                },
              },
              [
                _c("span", {
                  staticClass: "fa",
                  class:
                    _vm.globalExtendedPayment === _vm.relatedPaymentId
                      ? "fa-minus-circle"
                      : "fa-plus-circle",
                }),
              ]
            ),
          ])
        : _vm._e(),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }